import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import toTitleCase from '@clearscore/normalize.title-case';

import styles from './container.css';
import { themes, sizes, spacings } from './constants';

const Container = ({ size, theme, top, bottom, isFullHeight, dataId, children, isTranslucent }) => {
    const containerClass = cx(styles.container, styles[`isTheme${toTitleCase(theme)}`], {
        [styles.isFullHeight]: isFullHeight,
        [styles.isTranslucent]: isTranslucent,
    });
    const contentContainerClass = cx(
        styles.contentContainer,
        styles[`isSize${toTitleCase(size)}`],
        styles[`isTopSpacing${toTitleCase(top)}`],
        styles[`isBottomSpacing${toTitleCase(bottom)}`],
    );
    return (
        <div className={containerClass} data-qa="container" data-id={dataId}>
            <div className={contentContainerClass}>{children}</div>
        </div>
    );
};

Container.spacings = spacings;
Container.themes = themes;
Container.sizes = sizes;

Container.propTypes = {
    size: PropTypes.oneOf(Object.keys(sizes)),
    theme: PropTypes.oneOf(Object.keys(themes)),
    top: PropTypes.oneOf(Object.keys(spacings)),
    bottom: PropTypes.oneOf(Object.keys(spacings)),
    dataId: PropTypes.string,
    children: PropTypes.node.isRequired,
    isFullHeight: PropTypes.bool,
    isTranslucent: PropTypes.bool,
};

Container.defaultProps = {
    size: sizes.MAX,
    theme: themes.TRANSPARENT,
    top: spacings.NONE,
    bottom: spacings.NONE,
    dataId: undefined,
    isFullHeight: false,
    isTranslucent: false,
};

export default Container;
